<template>
  <div class="main">
    <van-nav-bar title="短信发送记录"
                 left-arrow
                 safe-area-inset-top
                 fixed
                 style="z-index: 99;"
                 @click-left="onClickLeft"/>

    <div class="content">

      <SmsSendRecordItem v-for="(item, index) in sendList"
                         :key="item.id"
                         :id="item.id"
                         :sms-status="item.smsStatus"
                         :date="item.sendTime"
                         :content="item.content"
                         @editSms="handleEditSms"
                         style="margin-bottom: 10px;"/>

    </div>

  </div>

  <!-- 编辑对话框 -->
  <van-popup 
    v-model:show="showEditDialog" 
    position="bottom" 
    class="edit-popup"
    round
  >
    <div class="edit-dialog">
      <div class="edit-title">
        修改短信内容
      </div>
      <van-field
        v-model="editContent"
        placeholder="请输入短信内容"
        maxlength="50"
        show-word-limit
        type="textarea"
        rows="4"
        class="edit-field"
      />
      <div class="edit-buttons">
        <van-button
          class="cancel-btn"
          @click="showEditDialog = false"
        >
          取消
        </van-button>
        <van-button
          class="confirm-btn"
          type="primary"
          color="#00D477"
          @click="confirmEdit"
        >
          确定
        </van-button>
      </div>
    </div>
  </van-popup>

</template>

<script>
import {NavBar, Dialog, Toast, Field, Popup, Button} from 'vant';
import {getPlanSendList, updateSmsContent} from "../../api/sms";
import SmsSendRecordItem from "../../components/plan/SmsSendRecordItem";

export default {
  name: "Record",
  components: {
    [NavBar.name]: NavBar,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Button.name]: Button,
    SmsSendRecordItem,
  },
  created() {
    this.id = this.$route.query.id;
    getPlanSendList(this.id)
        .then(res => {
          this.sendList = res.data.data
        })
  },
  data() {
    return {
      id: '',
      sendList: [],
      showEditDialog: false,
      editingId: '',
      editContent: ''
    }
  },

  methods: {
    onClickLeft() {
      history.back();
    },
    handleEditSms(id, content) {
      this.editingId = id;
      this.editContent = content;
      this.showEditDialog = true;
    },
    confirmEdit() {
      if (this.editContent.trim() === '') {
        Toast.fail('内容不能为空');
        return;
      }
      if (this.editContent.length > 50) {
        Toast.fail('内容不能超过50个字');
        return;
      }
      this.updateSmsContent(this.editingId, this.editContent);
      this.showEditDialog = false;
    },
    updateSmsContent(id, newContent) {
      Toast.loading({ forbidClick: true, duration: 0 });
      // let form = {
      //   id: id,
      //   content: newContent
      // }
      updateSmsContent({ id, content: newContent })
        .then(res => {
          Toast.clear();
          if (res.data.code === '00000') {
            Toast.success('修改成功');
            // 更新本地数据
            const item = this.sendList.find(item => item.id === id);
            if (item) {
              item.content = newContent;
            }
          } else {
            Toast.fail('修改失败，请重试');
          }
        })
        .catch(err => {
          Toast.clear();
          Toast.fail('修改失败，请重试');
        });
    }
  }
}
</script>

<style scoped>
.van-nav-bar {
  --van-nav-bar-icon-color: #292833;
  --van-nav-bar-text-color: #292833;
  background-color: #f7f7f7;
}

.main {
  height: 100vh;
  background-color: #f7f7f7;
  box-sizing: border-box;
}

.content {
  display: flex;
  flex-direction: column;
  padding: 48px 15px 15px;
  box-sizing: border-box;
  background-color: #f7f7f7;
}

/* 编辑对话框样式 */
.edit-popup {
  padding: 0;
}

.edit-dialog {
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
}

.edit-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #292833;
}

.edit-field {
  margin-bottom: 0;
}

.edit-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
}

.cancel-btn,
.confirm-btn {
  flex: 1;
  margin: 0;
}


</style>